import { createBrowserRouter, Navigate } from "react-router-dom";
import { PresentationView } from "../views/PresentationView/PresentationView";
import { PresentationsIndexView } from "../views/PresentationView/PresentationsIndexView";
import { VsaasView } from "../views/VsaasView/VsaasView";
import HomeView from "../views/HomeView/HomeView";
import { LoginView } from "../views/LoginView/LoginView";
import ProfileView from "../views/ProfileView/ProfileView";
import { ProfilePublicView } from "../views/ProfilePublicView/ProfilePublicView";
import { DocumentView } from "../views/DocumentsView/DocumentView";
import DiscoverView from "../views/DiscoverView/DiscoverView";
import GroupsHubView from "../views/GroupWallView/GroupsHubView";
import { CreateVotingViewV2 } from "../views/CreateVotingViewV2/CreateVotingViewV2";
import { CreateGroupViewV2 } from "../views/CreateGroupViewV2/CreateGroupViewV2";
import { RegisterView } from "../views/RegisterView/RegisterView";
import VotingsHubView from "../views/VotingsHubView/VotingsHubView";
import { RegistrationConfirmEmailSentScreen } from "../views/RegistrationConfirmEmailSentScreen/RegistrationConfirmEmailSentScreen";
import {
  addLeadEmailConfirmRouteLoader,
  landingPageLoader,
  loginRouteLoader,
  homeRouteLoader,
  organizerPathsLoader,
  registrationConfirmRouteLoader,
  removeAccountRouteLoader,
  voteConfirmRouteLoader
} from "@lubbezposrednio-frontend/core";
import { RegistrationConfirmView } from "../views/RegistrationConfirmView/RegistrationConfirmView";
import VotingView from "../views/VotingView/VotingView";
import { RegisterFailedView } from "../views/RegisterFailedView/RegisterFailedView";
import ForgotPasswordView from "../views/ForgotPasswordView/ForgotPasswordView";
import ResetPasswordView from "../views/ResetPasswordView/ResetPasswordView";
import { VerifyView } from "../views/VerifyView/VerifyView";
import { CyberspaceCallbackView } from "../views/VerifyView/CyberspaceCallbackView";
import { CyberidCallbackView } from "../views/LoginView/CyberidCallbackView";
import { CyberidVerifyCallbackView } from "../views/VotingView/CyberidVerifyCallbackView";
import { PasswordResetSuccessView } from "../views/PasswordResetSuccessView/PasswordResetSuccessView";
import { VotingConfirmEmailSentScreen } from "../views/VotingConfirmEmailSentScreen/VotingConfirmEmailSentScreen";
import { VoteConfirmScreen } from "../views/VoteConfirmScreen/VoteConfirmScreen";
import { VoterNotAllowedScreen } from "../views/VoterNotAllowedScreen/VoterNotAllowedScreen";
import { VoteConfirmFailedScreen } from "../views/VoteConfirmFailedScreen/VoteConfirmFailedScreen";
import { VotingFinishedScreen } from "../views/VotingFinishedScreen/VotingFinishedScreen";
import { VotingNotStartedScreen } from "../views/VotingNotStartedScreen/VotingNotStartedScreen";
import { AccessibilityDeclarationView } from "../views/AccessibilityDeclaration/AccessibilityDeclarationView";
import { AboutView } from "../views/AboutView/AboutView";
import { HowToVoteView } from "../views/HowToVoteView/HowToVoteView";
import { HowToCreateVotingView } from "../views/HowToCreateVotingView/HowToCreateVotingView";
import { FAQView } from "../views/FAQView/FAQView";
import { ZeroKnowledgeProofView } from "../views/ZeroKnowledgeProofView/ZeroKnowledgeProofView";
import { VotingSecurityView } from "../views/VotingSecurityView/VotingSecurityView";
import { SessionExpiredView } from "../views/SessionExpiredView/SessionExpiredView";
import { RemoveAccountConfirmScreen } from "../views/RemoveAccountConfirmScreen/RemoveAccountConfirmScreen";
import { RemoveAccountConfirmEmailSentScreen } from "../views/RemoveAccountConfirmEmailSentScreen/RemoveAccountConfirmEmailSentScreen";
import { RemoveAccountConfirmFailedScreen } from "../views/RemoveAccountConfirmFailedScreen/RemoveAccountConfirmFailedScreen";
import OrganizerDashboardView from "../views/OrganizerDashboardView/OrganizerDashboardView";
import StatsView from "../views/StatsView/StatsView";
import GroupDetailView from "../views/OrganizerGroupsView/GroupDetailView";
import { OrganizerLayout } from "../views/OrganizerDashboardView/components/OrganizerShell";
import { GroupSignupView } from "../views/GroupSignupView/GroupSignupView";
import { GroupSignupConfirmView } from "../views/GroupSignupView/GroupSignupConfirmView";
import { PlaceholderView } from "../views/PlaceholderView/PlaceholderView";
import { ApiDocsView } from "../views/DeveloperView/ApiDocsView";
import { ApiKeysView } from "../views/DeveloperView/ApiKeysView";
import { ResultsView } from "../views/ResultsView/ResultsView";
import VotingManageView from "../views/VotingManageView/VotingManageView";
import GroupHubView from "../views/GroupWallView/GroupHubView";
import PostDetailView from "../views/GroupWallView/PostDetailView";
import PortalPostDetailView from "../views/DiscoverView/PortalPostDetailView";
import { FiBook, FiKey } from "react-icons/fi";
import { Screen404, ServerErrorScreen } from "@lubbezposrednio-frontend/commons";
import { AddEmailConfirmScreen } from "../views/AddEmailConfirmScreen/AddEmailConfirmScreen";
import { AddEmailFailedScreen } from "../views/AddEmailFailedScreen/AddEmailFailedScreen";
import LandingPageView from "../views/LandingPageView/LandingPageView";
import { HowToUseExplorerView } from "../views/HowToUseExplorerView/HowToUseExplorerView";
import { useParams } from "react-router-dom";

// Stary adres /sciana → zunifikowany widok grupy (:id).
const GroupScianaRedirect = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/organizator/grupy/${id}`} replace />;
};

export const router = createBrowserRouter([
  {
    path: "/prezentacja",
    element: <PresentationsIndexView />
  },
  {
    path: "/prezentacja/:deckSlug",
    element: <PresentationView />
  },
  {
    path: "/prezentacja/:deckSlug/prezenter",
    element: <PresentationView presenter />
  },
  {
    path: "/prezentacja/:deckSlug/:index",
    element: <PresentationView />
  },
  {
    path: "/",
    element: <HomeView />,
    loader: homeRouteLoader,
    errorElement: <Screen404 />
  },
  {
    path: "/zapisy/potwierdzenie",
    element: <GroupSignupConfirmView />
  },
  {
    path: "/zapisy/:token",
    element: <GroupSignupView />
  },
  {
    path: "/profil/:ref",
    element: <ProfilePublicView />
  },
  {
    path: "/regulamin",
    element: <DocumentView type="terms_of_service" />
  },
  {
    path: "/polityka-prywatnosci",
    element: <DocumentView type="privacy_policy" />
  },
  {
    path: "/deklaracja-dostepnosci",
    element: <DocumentView type="accessibility" />
  },
  {
    path: "/standardy-bezpieczenstwa-dzieci",
    element: <DocumentView type="child_safety" />
  },
  {
    path: "/vsaas",
    element: <VsaasView />
  },
  {
    path: "/nie-znaleziono-strony",
    element: <Screen404 />
  },
  {
    path: "/logowanie",
    element: <LoginView />,
    loader: loginRouteLoader
  },
  {
    // Powrót z CyberID (OIDC) — publiczny, BEZ loginRouteLoader (nie odbijaj przed utrwaleniem sesji).
    path: "/logowanie/cyberid/powrot",
    element: <CyberidCallbackView />
  },
  {
    // Powrót z weryfikacji tożsamości CyberID (per głosowanie) — publiczny; zapisuje asercję i wraca na głosowanie.
    path: "/weryfikacja/cyberid/powrot",
    element: <CyberidVerifyCallbackView />
  },
  {
    path: "/rejestracja",
    element: <RegisterView />
  },
  {
    path: "/wyslanie-maila-z-potwierdzeniem-rejestracji",
    element: <RegistrationConfirmEmailSentScreen />
  },
  {
    path: "/potwierdzenie-rejestracji",
    element: <RegistrationConfirmView />,
    loader: registrationConfirmRouteLoader
  },
  {
    // Odkrywanie głosowań przeniesione do huba (tylko zalogowani) — stary publiczny adres przekierowuje.
    path: "/aktywne-glosowania",
    element: <Navigate to="/organizator/glosowania?w=odkrywaj" replace />
  },
  {
    // Społeczność/Odkrywaj tylko dla zalogowanych — stary publiczny adres przekierowuje (loader → logowanie, gdy brak sesji).
    path: "/odkrywaj",
    element: <Navigate to="/organizator/odkrywaj" replace />
  },
  {
    path: "/organizator/odkrywaj",
    element: <DiscoverView />,
    loader: organizerPathsLoader
  },
  {
    path: "/glosowanie/:id",
    element: <VotingView />
  },
  {
    path: "/blad-potwierdzenia-rejestracji",
    element: <RegisterFailedView />
  },
  {
    path: "/blad-serwera",
    element: <ServerErrorScreen />
  },
  {
    path: "/zapomnialem-hasla",
    element: <ForgotPasswordView />
  },
  {
    path: "/ustaw-haslo",
    element: <ResetPasswordView />
  },
  {
    path: "/weryfikacja",
    element: <VerifyView />
  },
  {
    path: "/auth/cyberspace/callback",
    element: <CyberspaceCallbackView />
  },
  {
    path: "/sukces-resetu-hasla",
    element: <PasswordResetSuccessView />
  },
  {
    path: "/wyslanie-maila-z-potwierdzeniem-glosowania",
    element: <VotingConfirmEmailSentScreen />
  },
  {
    path: "/glosowanie/:id/nieuprawiony-email",
    element: <VoterNotAllowedScreen />
  },
  {
    path: "/glosowanie/:id/zakonczone",
    element: <VotingFinishedScreen />
  },
  {
    path: "/glosowanie/:id/planowane",
    element: <VotingNotStartedScreen />
  },
  {
    path: "/potwierdzenie-glosowania",
    element: <VoteConfirmScreen />,
    loader: voteConfirmRouteLoader
  },
  {
    path: "/wyslanie-maila-z-potwierdzeniem-usuniecia-konta",
    element: <RemoveAccountConfirmEmailSentScreen />
  },
  {
    path: "/potwierdzenie-usuniecia-konta",
    element: <RemoveAccountConfirmScreen />,
    loader: removeAccountRouteLoader
  },
  {
    path: "/blad-potwierdzenia-usuniecia-konta",
    element: <RemoveAccountConfirmFailedScreen />
  },
  {
    path: "/glosowanie/:id/blad-potwierdzenia-glosowania",
    element: <VoteConfirmFailedScreen />
  },
  {
    path: "/deklaracja-dostepnosci",
    element: <AccessibilityDeclarationView />
  },
  {
    path: "/o-nas",
    element: <AboutView />
  },
  {
    path: "/jak-stworzyc-glosowanie",
    element: <HowToCreateVotingView />
  },
  {
    path: "/jak-zaglosowac",
    element: <HowToVoteView />
  },
  {
    path: "/faq",
    element: <FAQView />
  },
  {
    path: "/tajne-glosowanie-zkp",
    element: <ZeroKnowledgeProofView />
  },
  {
    path: "/tozsamosc-i-bezpieczenstwo",
    element: <VotingSecurityView />
  },
  {
    path: "/sesja-wygasla",
    element: <SessionExpiredView />
  },
  {
    path: "/potwierdzenie-zapisu-na-liste",
    element: <AddEmailConfirmScreen />,
    loader: addLeadEmailConfirmRouteLoader
  },
  {
    path: "/blad-potwierdzenia-zapisu-na-liste",
    element: <AddEmailFailedScreen />
  },
  {
    path: "/zapis-na-glosowanie/:id",
    element: <LandingPageView />,
    loader: landingPageLoader
  },
  {
    path: "/eksplorer-jak-korzystac",
    element: <HowToUseExplorerView />
  },

  {
    path: "/organizator",
    loader: organizerPathsLoader,
    element: <OrganizerLayout />,
    children: [
      {
        index: true,
        element: <OrganizerDashboardView />
      },
      {
        path: "/organizator/statystyki",
        element: <StatsView />
      },
      {
        // Zunifikowany hub grup: zakładki Aktywność / Należę / Zarządzam / Odkrywaj (?w=)
        path: "/organizator/grupy",
        element: <GroupsHubView />
      },
      {
        path: "/organizator/grupy/nowa",
        element: <CreateGroupViewV2 />
      },
      {
        // Zunifikowany widok grupy = hub społecznościowy; ustawienia jako zakładka (właściciel).
        path: "/organizator/grupy/:id",
        element: <GroupHubView />
      },
      {
        // Permalink pojedynczego posta (deep-link z powiadomień) — „pro" obsługa.
        path: "/organizator/grupy/:groupId/post/:postId",
        element: <PostDetailView />
      },
      {
        // Permalink posta portalowego (deep-link z powiadomień).
        path: "/organizator/post-portalowy/:id",
        element: <PortalPostDetailView />
      },
      {
        path: "/organizator/glosowanie/:id",
        element: <VotingManageView />
      },
      {
        path: "/organizator/glosowanie/:id/wyniki",
        element: <ResultsView />
      },
      {
        // Zunifikowany hub głosowań: Biorę udział / Autorskie / Odkrywaj (?w=)
        path: "/organizator/glosowania",
        element: <VotingsHubView />
      },
      {
        path: "/organizator/udzial",
        element: <Navigate to="/organizator/glosowania" replace />
      },
      {
        // Stare adresy zakładek → zunifikowany hub z odpowiednią zakładką.
        path: "/organizator/moje-grupy",
        element: <Navigate to="/organizator/grupy?w=naleze" replace />
      },
      {
        path: "/organizator/grupy-feed",
        element: <Navigate to="/organizator/grupy?w=aktywnosc" replace />
      },
      {
        // Stary adres ściany → zunifikowany widok grupy.
        path: "/organizator/grupy/:id/sciana",
        element: <GroupScianaRedirect />
      },
      {
        path: "/organizator/dokumentacja",
        element: <ApiDocsView />
      },
      {
        path: "/organizator/api",
        element: <ApiKeysView />
      },
      {
        path: "/organizator/utworz-glosowanie",
        element: <CreateVotingViewV2 />
      },
      {
        path: "/organizator/twoje-glosowania",
        element: <Navigate to="/organizator/glosowania?w=autorskie" replace />
      },
      {
        path: "/organizator/zgody",
        element: <Navigate to="/organizator/konto" replace />
      },
      {
        path: "/organizator/konto",
        element: <ProfileView />
      }
    ]
  }
]);
